import { ChevronLeft, ChevronRight } from "lucide-react";

const pageList = (page, totalPages) => {
  if (totalPages <= 7) return Array.from({ length: totalPages }, (_, i) => i + 1);
  const out = [1];
  const left = Math.max(2, page - 1);
  const right = Math.min(totalPages - 1, page + 1);
  if (left > 2) out.push("ellipsis-l");
  for (let i = left; i <= right; i++) out.push(i);
  if (right < totalPages - 1) out.push("ellipsis-r");
  out.push(totalPages);
  return out;
};

export const BookingsPagination = ({ page, totalPages, total, pageSize, onPageChange, testid = "pagination" }) => {
  const start = total === 0 ? 0 : (page - 1) * pageSize + 1;
  const end = Math.min(page * pageSize, total);
  const go = (p) => { if (p >= 1 && p <= totalPages && p !== page) onPageChange(p); };

  return (
    <div
      className="mt-4 flex flex-col gap-3 border-t border-slate-100 pt-4 sm:flex-row sm:items-center sm:justify-between"
      data-testid={`${testid}-bar`}
    >
      <p className="text-xs text-[#64748B]" data-testid={`${testid}-range`}>
        Showing <span className="font-semibold text-[#0F172A]">{start}–{end}</span> of{" "}
        <span className="font-semibold text-[#0F172A]">{total}</span> bookings
      </p>
      <div className="-mx-1 overflow-x-auto">
        <nav className="flex w-max items-center gap-1 px-1" aria-label="pagination">
          <button
            onClick={() => go(page - 1)}
            disabled={page <= 1}
            className="flex items-center gap-1 rounded-lg border border-slate-300 px-2.5 py-1.5 max-sm:min-h-[44px] max-sm:min-w-[44px] text-xs font-semibold text-[#0F172A] transition-all hover:bg-slate-50 disabled:cursor-not-allowed disabled:opacity-40"
            data-testid={`${testid}-prev`}
          >
            <ChevronLeft className="h-4 w-4" /> Previous
          </button>
          {pageList(page, totalPages).map((p, i) =>
            typeof p === "string" ? (
              <span key={p + i} className="px-1.5 text-sm text-[#94a3b8]" data-testid={`${testid}-ellipsis`}>…</span>
            ) : (
              <button
                key={p}
                onClick={() => go(p)}
                aria-current={p === page ? "page" : undefined}
                className={`min-w-[34px] rounded-lg px-2.5 py-1.5 max-sm:min-h-[44px] max-sm:min-w-[44px] text-xs font-semibold transition-all ${
                  p === page ? "bg-[#5C2D91] text-white" : "border border-slate-300 text-[#0F172A] hover:bg-slate-50"
                }`}
                data-testid={`${testid}-page-${p}`}
              >
                {p}
              </button>
            ),
          )}
          <button
            onClick={() => go(page + 1)}
            disabled={page >= totalPages}
            className="flex items-center gap-1 rounded-lg border border-slate-300 px-2.5 py-1.5 max-sm:min-h-[44px] max-sm:min-w-[44px] text-xs font-semibold text-[#0F172A] transition-all hover:bg-slate-50 disabled:cursor-not-allowed disabled:opacity-40"
            data-testid={`${testid}-next`}
          >
            Next <ChevronRight className="h-4 w-4" />
          </button>
        </nav>
      </div>
    </div>
  );
};
